import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const AlertInputModal = ({
    modalTitle = "",
    show,
    setShow,
    setConfirm,
    value,
    onChangeValue,
    initialValue,
    isNew,
}) => {
    const handleSave = () => {
        setConfirm(true);
        setShow(false);
    };

    return (
        <Modal
            size="md"
            className="alert-confirm-modal"
            centered
            show={show}
            onHide={() => setShow(false)}
        >
            {modalTitle && (
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body>
                <input
                    type="text"
                    placeholder="Name"
                    value={value}
                    defaultValue={!isNew ? initialValue : ""}
                    onChange={(e) => onChangeValue(e.target.value)}
                />
                <div className="alertconfirm-btns">
                    <Button onClick={handleSave} variant="secondary">
                        Save
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default AlertInputModal;
